// extracted by mini-css-extract-plugin
export default {"renameIcon":"OrganizeSeriesModalContent-renameIcon-m1IkV","message":"OrganizeSeriesModalContent-message-dxZmd"};